import { ReactNode } from "react";

import { cva } from "class-variance-authority";

import CheckWithCircle from "shared/assets/svg/check-with-circle.svg?react";
import DoubleArrowRight from "shared/assets/svg/double-arrow-right.svg?react";
import { cn } from "shared/utils/cn";

import checksBg from "../assets/checks-bg.png";
import keysBg from "../assets/keys-bg.png";
import locksBg from "../assets/locks-bg.png";

const variants = cva(
  "relative flex cursor-pointer flex-col overflow-hidden rounded-xl p-4.5 transition-colors hover:brightness-125",
  {
    variants: {
      status: {
        active: "persian-orange-gradient text-white",
        completed: "pointer-events-none apple-gradient text-white",
        blocked: "pointer-events-none quill-grey-gradient text-aluminium",
      },
    },
  }
);

type TaskStatus = "active" | "completed" | "blocked";

const getBg = (status: TaskStatus) => {
  if (status === "active") return keysBg;
  if (status === "completed") return checksBg;
  return locksBg;
};

type Props = {
  className?: string;
  title: ReactNode;
  reward: number;
  description?: string;
  onClick: () => void;
  status: TaskStatus;
};

export const Card = (props: Props) => {
  const { title, status = "active", className, reward, onClick } = props;

  return (
    <div
      style={{
        boxShadow: "0px 11px 19.1px -10px #311C0F3B",
      }}
      className={cn(variants({ className, status }))}
      onClick={onClick}
    >
      <div
        className={cn(
          "absolute inset-0 z-0 bg-cover bg-no-repeat",
          status === "blocked" && "opacity-25"
        )}
        style={{
          backgroundImage: `url(${getBg(status)})`,
        }}
      ></div>
      <div className="relative z-10">
        <h3 className={"text-xl font-semibold"}>{title}</h3>
        <p className="text-sm">+{reward} REP</p>
        {status === "completed" && (
          <CheckWithCircle className="absolute top-1/2 right-4 h-12 -translate-y-1/2 text-white opacity-90" />
        )}
        {status !== "completed" && (
          <DoubleArrowRight
            className={cn(
              "absolute top-1/2 right-4 h-12 -translate-y-1/2 text-white opacity-90",
              status === "active" && "animate-float-x"
            )}
          />
        )}
      </div>
    </div>
  );
};
